var map = {
	"./Capture.PNG": [
		3823,
		823
	],
	"./Dashboard/GroupRegistrationReport_01-09-2025.xlsx": [
		2790,
		790
	],
	"./Dashboard/GroupRegistrationReport_02-09-2025 (1).xlsx": [
		1053,
		53
	],
	"./Dashboard/GroupRegistrationReport_02-09-2025.xlsx": [
		7967,
		967
	],
	"./Dashboard/Money.svg": [
		4359,
		359
	],
	"./Dashboard/graph.svg": [
		3615,
		615
	],
	"./EventDefaultImage.svg": [
		2472,
		472
	],
	"./Nationality.png": [
		4308,
		308
	],
	"./No_Image_Available.jpg": [
		7363
	],
	"./add-ons.svg": [
		8414,
		414
	],
	"./birthday.png": [
		6891,
		891
	],
	"./flags/kw.svg": [
		5616,
		616
	],
	"./fonts/graphik-arabic-medium.woff2": [
		1584
	],
	"./fonts/graphik-arabic-regular.woff2": [
		3843
	],
	"./fonts/graphik-medium.woff2": [
		8065
	],
	"./fonts/graphik-regular.woff2": [
		5456
	],
	"./icons/arrow-left-line.png": [
		5079
	],
	"./icons/arrow-right-line.png": [
		9588
	],
	"./icons/choose_file.png": [
		7545,
		545
	],
	"./icons/choose_file.svg": [
		7138,
		757
	],
	"./icons/cms.svg": [
		8002,
		2
	],
	"./icons/cms1.svg": [
		6207,
		207
	],
	"./icons/customer.svg": [
		7511,
		511
	],
	"./icons/dashboard .svg": [
		8751,
		751
	],
	"./icons/down.png": [
		1505,
		505
	],
	"./icons/event.svg": [
		7449,
		449
	],
	"./icons/icon-field.svg": [
		7431,
		431
	],
	"./icons/icon-google-marker.svg": [
		899,
		899
	],
	"./icons/icon-sider-trigger.svg": [
		6013,
		13
	],
	"./icons/icon-triangle.svg": [
		7069,
		69
	],
	"./icons/logout.svg": [
		4277,
		277
	],
	"./icons/logs.svg": [
		326,
		326
	],
	"./icons/notification .svg": [
		602,
		602
	],
	"./icons/pdf_icon.png": [
		7079
	],
	"./icons/pencil-line.png": [
		1971,
		971
	],
	"./icons/settings-5-fill.png": [
		7288,
		288
	],
	"./icons/shop_item.svg": [
		8959,
		959
	],
	"./icons/transaction.svg": [
		7645,
		645
	],
	"./icons/transfer.svg": [
		7422,
		422
	],
	"./icons/user.svg": [
		698,
		698
	],
	"./icons/vending-machine.svg": [
		4022,
		22
	],
	"./increase.svg": [
		5358,
		358
	],
	"./logo2.png": [
		4343
	],
	"./main_login.png": [
		1033
	],
	"./newlogo.png": [
		5005,
		5
	],
	"./newlogo.svg": [
		1057,
		57
	],
	"./participate.svg": [
		1526,
		526
	],
	"./patten_01.png": [
		9376
	],
	"./patten_02.png": [
		4411
	],
	"./patterned-background.svg": [
		792,
		411
	],
	"./refund .svg": [
		4216,
		216
	],
	"./revenue.svg": [
		8758,
		758
	],
	"./spiner.svg": [
		5831,
		831
	],
	"./suffix-admin-logo.svg": [
		2181,
		181
	],
	"./suffix-logo.svg": [
		3451,
		451
	],
	"./tickets.svg": [
		6429,
		429
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8388;
module.exports = webpackAsyncContext;